import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import search from "../../Images/search.png";
import "./SearchBar.css";

const SearchComponent = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [allFunds, setAllFunds] = useState([]);
  const [filteredResults, setFilteredResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://redvisionweb.com/api/all-scheme-portfolio?apikey=351b03c24a79d2f40796037e0d8c2c49"
        );
        if (!response.ok) throw new Error("Failed to fetch");

        const data = await response.json();
        if (!data.data || !Array.isArray(data.data)) throw new Error("Invalid data format");

        setAllFunds(data.data);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (searchQuery.length < 3) {
      setFilteredResults([]);
      return;
    }

    const debounceTimer = setTimeout(() => {
      const filtered = allFunds.filter((item) =>
        item.funddes.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredResults(filtered);
    }, 300);

    return () => clearTimeout(debounceTimer);
  }, [searchQuery, allFunds]);

  const handleSearch = (item) => {
    const slug = item.funddes
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, "")
      .trim()
      .replace(/\s+/g, "-")
      .replace(/--+/g, "-")
      .replace(/^-+|-+$/g, "");

    // // Save to sessionStorage for reload fallback
    // sessionStorage.setItem("mf-data", JSON.stringify({ slug, id: item.pcode }));

    // Navigate using route state (URL will be clean)
    navigate("/mf-single-fund", {
      state: {
        slug,
        id: item.pcode,
      },
    });

    setSearchQuery("");
  };

  return (
    <div className="p-4">
      <div className="searchbar">
        <img src={search} alt="Search" />
        <input
          type="text"
          className="border border-gray-300 p-2 rounded-md w-full"
          placeholder="Search Mutual Funds"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <div className="loader">
        {error && <p style={{ color: "red" }}>{error}</p>}
      </div>

      {filteredResults.length > 0 && (
        <ul className="search-result-box mt-3 border border-gray-200 rounded-md p-2 max-h-[300px] overflow-y-auto">
          {filteredResults.map((result, index) => (
            <li
              key={index}
              className="p-2 bg-gray-100 rounded-md mb-2 cursor-pointer"
              onClick={() => handleSearch(result)}
            >
              {result.funddes}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SearchComponent;
